import ConnectedFlyout from './Container';

export default ConnectedFlyout;
